module.exports = __webpack_public_path__ + "img/arrow_back_black.5bbf15c6.svg";